import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Home from '../views/Home.vue'
import Profile from '../views/Profile.vue'
import Settings from '../views/Settings.vue'

// 导入商城路由配置
import { storeRoutes } from './store'
// 导入系统管理路由配置
import { systemRoutes } from './system'
// 导入用户管理路由配置
import { userRoutes } from './user'
// 导入广告管理路由配置
import { adRoutes } from './ad'
// 导入测试管理路由配置
import { testRoutes } from './test'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/dashboard',
    component: Dashboard,
    meta: {
      title: '后台管理系统',
      requiresAuth: true
    },
    children: [
      {
        path: '',
        redirect: '/dashboard/store/store-home'
      },
      // 首页已废弃，直接进入商城概览
      // {
      //   path: 'home',
      //   name: 'Home',
      //   component: Home,
      //   meta: {
      //     title: '首页',
      //     icon: 'el-icon-s-home',
      //     hidden: false
      //   }
      // },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
        meta: {
          title: '个人中心',
          icon: 'el-icon-user',
          hidden: true
        }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
        meta: {
          title: '系统设置',
          icon: 'el-icon-setting',
          hidden: true
        }
      },
      storeRoutes,
      userRoutes,
      adRoutes,
      systemRoutes,
      testRoutes
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  // 检查是否需要登录
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('token')
    if (!token) {
      next('/login')
      return
    }
  }
  
  // 如果已登录，访问登录页则跳转到首页
  if (to.path === '/login') {
    const token = localStorage.getItem('token')
    if (token) {
      next('/dashboard')
      return
    }
  }
  
  next()
})

export default router